import React from 'react';
import { observer } from 'mobx-react';
import { samplingDistributions } from 'mobx-store';

import NumericalComponent from './Component';

const NumericalContainer = observer(
  class NumericalContainer extends React.Component {
    render () {
      return (
        <NumericalComponent
          parameterName={samplingDistributions.parameter.name}
          randomSampleValues={samplingDistributions.selectedSample}
          originalSampleValues={samplingDistributions.parameter.values}
          randomSampleSummary={samplingDistributions.selectedSampleSummary}
          originalSampleSummary={samplingDistributions.originalSampleSummary}
        />
      );
    }
  }
);

export default NumericalContainer;
